import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { Modal } from 'antd-mobile'

import { requestPayment } from '../../actions/orderActions';
import useDidMountEffect from '../../hooks/useDidMountEffect';
import useTimeWork from '../../hooks/useTimeWork';
import paths from '../../routes/paths';

import MenuIcon from '../../assets/icons/restaurant-menu.png';
import BellIcon from '../../assets/icons/bell.png';
import OrderHistoryIcon from '../../assets/icons/order-history.png';
import BillIcon from '../../assets/icons/bill.png';

import { clsx, disableBrowserBack, getWaitingTimeNextRequestPayment, showMessageSuccess, showMessageWarn } from '../../utils/helper';
import { APP_SERVICE, ORDER_METHOD, REQUEST_KINDS } from '../../constants';
import { getRestaurantSettings } from '../../selectors';
import useOrder from '../../hooks/useOrder';

const alert = Modal.alert;

const OrderTableQRcodeSuccess = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { isOvertime } = useTimeWork();
    const history = useHistory();

    const { lastTimeRequestPayment } = useSelector(state => state.OrderReducer);
    const { lastTimeRequestSupporter } = useSelector(state => state.OrderReducer);
    const { tableSetting } = useSelector(getRestaurantSettings);

    const [timeReqPmt, setTimeReqPmt] = useState(getWaitingTimeNextRequestPayment(lastTimeRequestPayment));
    const [timeReqSupporter, setTimeReqSupporter] = useState(getWaitingTimeNextRequestPayment(lastTimeRequestSupporter));

    const { foodsOrdering } = useOrder();

    const handleRequestPayment = kind => {
        dispatch(
            requestPayment({
                params: { kind },
                onDone: isSuccess => {
                    if (isSuccess) {
                        showMessageSuccess(t(kind === REQUEST_KINDS.payment ? 'cartMobile.mesRequestPaymentSuccess' : 'cartMobile.mesRequestSupportSuccess'));
                    }
                }
            })
        );
    }

    useEffect(() => {
        disableBrowserBack();

        return () => {}
    }, [])

    useEffect(() => {
        let timeOut
        if (!!timeReqPmt) {
            timeOut = setTimeout(
                () => setTimeReqPmt(getWaitingTimeNextRequestPayment(lastTimeRequestPayment)),
                1000
            )
        }

        return () => {
            timeOut && clearTimeout(timeOut)
        }
    }, [timeReqPmt, lastTimeRequestPayment])

    useDidMountEffect(() => {
        const time = getWaitingTimeNextRequestPayment(lastTimeRequestPayment)
        time && setTimeReqPmt(time)
    }, [lastTimeRequestPayment])

    useEffect(() => {
        let timeOut
        if (!!timeReqSupporter) {
            timeOut = setTimeout(
                () => setTimeReqSupporter(getWaitingTimeNextRequestPayment(lastTimeRequestSupporter)),
                1000
            )
        }

        return () => {
            timeOut && clearTimeout(timeOut)
        }
    }, [timeReqSupporter, lastTimeRequestSupporter])

    useDidMountEffect(() => {
        const time = getWaitingTimeNextRequestPayment(lastTimeRequestSupporter)
        time && setTimeReqSupporter(time)
    }, [lastTimeRequestSupporter])

    const actions = [
        {
            label: 'tableQrcodeSuccess.continueOrder',
            icon: MenuIcon,
            onClick: () => {
                history.push({
                    pathname: paths.home,
                    state: {
                        from: paths.tableQRcodeSuccess
                    }
                });
            },
        },
        {
            label: 'tableQrcodeSuccess.viewOrder',
            icon: OrderHistoryIcon,
            onClick: () => history.push({
                pathname: paths.cartDetail,
                state: {
                    from: paths.tableQRcodeSuccess
                }
            })
        },
        {
            label: 'tableQrcodeSuccess.supporter',
            icon: BellIcon,
            onClick: () => handleRequestPayment(REQUEST_KINDS.supporter),
            disabled: isOvertime || !!timeReqSupporter,
            showTime: !!timeReqSupporter ? ` (${timeReqSupporter})` : ''
        },
        {
            label: 'tableQrcodeSuccess.requestPayment',
            icon: BillIcon,
            onClick: () => {
                if (foodsOrdering.length) {
                    showMessageWarn(t('tableQrcodeSuccess.mesSubmitOrderFirst'))
                } else {
                    alert(
                        '',
                        t('tableQrcodeSuccess.requestPayment'),
                        [
                            { text: t('tableQrcodeSuccess.btnAgreeReqPmt'), onPress: () => handleRequestPayment(REQUEST_KINDS.payment) },
                            { text: t('tableQrcodeSuccess.btnCancel'), onPress: () => {} },
                        ]
                    );
                }
            },
            disabled: isOvertime || !!timeReqPmt,
            showTime: !!timeReqPmt ? ` (${timeReqPmt})` : ''
        },
    ]

    // if (APP_SERVICE !== ORDER_METHOD.QR_CODE) {
    //     return <Redirect to={paths.home} />
    // }

    return (
        <div className="table-qrcode-success-actions">
            {actions.map(({
                label,
                icon,
                disabled,
                showTime,
                onClick,
                ...props
            }, index) => (
                <div
                    className={clsx('action-item', disabled && 'disabled')}
                    key={index}
                    {...props}
                    onClick={() => !disabled && onClick()}
                >
                    <img src={icon} />
                    <div>
                        {t(label) + (showTime || '')}
                    </div>
                </div>
            ))}

            {tableSetting?.footer_message && (
                <div className="footer-message">
                    {tableSetting?.footer_message}
                </div>
            )}
        </div>
    );
};

export default OrderTableQRcodeSuccess;